<template>
  <tab-header :title="title">
    <div class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item of breadcrumb" :key="item.text" :to="item.to" :replace="true">
          {{ item.text }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </tab-header>
</template>

<script>
import TabHeader from './tab-header.vue';
export default {
  name: 'Breadcrumb',
  components: {
    TabHeader,
  },
  props: {
    breadcrumb: {
      type: Array,
      default: () => [],
    },
    title: String,
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
// 重写 element-ui 样式
/deep/.el-breadcrumb__inner.is-link {
  color: #999999;
  font-weight: 400;
}
/deep/.el-breadcrumb__inner {
  color: #333333;
}

// 正常样式
.container {
  height: 31px;
}
</style>
